import React from "react";
import { Phone, MessageCircle, Store, ShoppingBag } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { CONTACT } from "@/data/site";
import { Reveal, Kicker } from "./Reveal";
import { openWhatsApp } from "@/lib/wa";

export default function OrderCTA() {
  const { t } = useLang();
  return (
    <section className="relative py-24 md:py-32" data-testid="order-section">
      <div className="mx-auto max-w-5xl px-5 text-center md:px-10">
        <Kicker className="mb-6 justify-center">{t.orderKicker}</Kicker>
        <Reveal>
          <div className="mb-6 flex items-center justify-center gap-6 text-[var(--gold)]">
            <Store size={26} />
            <span className="h-px w-10 bg-[var(--gold)]/40" />
            <ShoppingBag size={26} />
          </div>
          <h2 className="font-serif text-5xl leading-[1] tracking-tight text-[var(--text)] md:text-7xl">
            {t.orderTitle}
          </h2>
          <p className="mx-auto mt-6 max-w-xl font-sans text-[15px] leading-relaxed text-[var(--text-2)]">
            {t.orderIntro}
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={`tel:${CONTACT.phoneTel}`}
            data-testid="order-call-btn"
            className="group flex w-full items-center justify-center gap-3 border border-[var(--gold)] px-8 py-5 font-sans text-[15px] tracking-wide text-[var(--gold)] transition-colors hover:bg-[var(--gold)]/10 sm:w-auto"
          >
            <Phone size={19} />
            <span>{t.callBtn}</span>
            <span className="font-semibold">{CONTACT.phoneDisplay}</span>
          </a>
          <button
            onClick={() => openWhatsApp(t.waOrder)}
            data-testid="order-whatsapp-btn"
            className="group flex w-full items-center justify-center gap-3 bg-[var(--gold)] px-8 py-5 font-sans text-[15px] font-semibold tracking-wide text-[var(--bg)] transition-transform hover:scale-[1.02] sm:w-auto"
          >
            <MessageCircle size={19} />
            {t.waBtn}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
